import styled, { css } from 'styled-components';
import { livePageResponsiveWithSidebar } from '../../styled/utils';
import EmptyWidgetShirt from '../../images/widget_shirt.png';

export const LiveSectionContent = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    flex-wrap: wrap;
    box-sizing: border-box;

    nav.view-horizontal-navigation {
        padding: 0;
    }
`;

export const LiveSectionTop = styled.div`
    display: flex;
    align-items: center;
    width: 100%;

    ${({ $isLeftSideBarOpen }) =>
        livePageResponsiveWithSidebar(
            $isLeftSideBarOpen,
            css`
                flex-direction: column;
            `
        )};
`;

export const MainContentLiveWrapper = styled.div`
    display: flex;
    width: 100%;
    padding-inline: ${({ $isMobile }) => ($isMobile ? '16px' : '0')};
`;

export const NavigationLiveWrapper = styled.div`
    width: 60%;
    overflow: hidden;
    margin-bottom: ${({ $isMobile }) => ($isMobile ? '6px' : '22px')};
    margin-top: 16px;

    .view-horizontal-navigation {
        margin: 0;
    }

    ${({ $isLeftSideBarOpen }) =>
        livePageResponsiveWithSidebar(
            $isLeftSideBarOpen,
            css`
                width: 100%;
                order: unset;
                margin-top: 0;
            `
        )};
`;

export const SearchLiveWrapper = styled.div`
    order: 1;
    width: 40%;
    box-sizing: border-box;
    padding-inline: ${({ $isMobile }) => ($isMobile ? '16px' : '26px 0')};

    ${({ $isLeftSideBarOpen, $isMobile }) =>
        livePageResponsiveWithSidebar(
            $isLeftSideBarOpen,
            css`
                width: 100%;
                order: unset;
                padding-inline: ${({ $isMobile }) =>
                    $isMobile ? '16px' : '0'};
                margin-bottom: 16px;
            `
        )};
`;

export const MainContentLiveBlock = styled.div`
    width: 60%;
    flex-grow: 1;
    align-self: flex-start;

    ${({ $isLeftSideBarOpen }) =>
        livePageResponsiveWithSidebar(
            $isLeftSideBarOpen,
            css`
                width: 100%;
            `
        )};
`;
export const WidgetLiveWrapper = styled.div`
    align-self: flex-start;
    width: 40%;
    box-sizing: border-box;
    padding-left: 26px;

    ${({ $isLeftSideBarOpen }) =>
        livePageResponsiveWithSidebar(
            $isLeftSideBarOpen,
            css`
                display: none;
            `
        )};
`;

export const EmptyWidgetWrapper = styled.div`
    border-radius: 0 0 4px 4px;
    border: 1px solid ${({ theme }) => theme.borders.primaryBorder};
    background: #fff;
    overflow: hidden;
`;

export const EmptyWidgetTop = styled.div`
    display: flex;
    justify-content: center;
    gap: 5px;
    align-items: center;
    position: relative;
    padding-inline: 64px;
    box-sizing: border-box;
    height: 56px;
    border-bottom: 1px solid ${({ theme }) => theme.borders.primaryBorder};
    overflow: hidden;

    ${({ $showBg }) =>
        $showBg &&
        css`
            justify-content: space-between;

            &::before,
            &::after {
                content: '';
                position: absolute;
                top: 8px;
                background: url(${EmptyWidgetShirt}) no-repeat center bottom;
                background-size: contain;
                height: 96px;
                width: 96px;
            }

            &::before {
                left: -40px;
            }

            &::after {
                right: -40px;
            }
        `};
`;

export const EmptyWidgetBottom = styled.div`
    min-height: 122px;
    padding: 37px 20px;
    box-sizing: border-box;
`;

export const EmptyWidgetTeam = styled.div`
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    color: ${({ theme }) => theme.text.black};
    width: 40%;
    text-align: ${({ $textAlign }) => $textAlign || 'left'};
`;
